import { CreateService, CRUDServiceInterface } from '@/services/service';
import APIBuilder from '@quangphuc/frontend-api-builder';
import { DailyReportEntity } from '@/entities/daily-report.entity';

export default class DailyReportService
  extends CreateService<DailyReportEntity>('daily-report')
  implements CRUDServiceInterface<DailyReportEntity>
{
  async getOne(
    id: number,
    join: string[] = ['staff', 'emoticon', 'company'],
  ): Promise<DailyReportEntity> {
    return super.getOne(id, join);
  }
  async upload(id: number, instance: { file: File }): Promise<void> {
    if (!instance.file) return;
    const formData = new FormData();
    if (instance.file) {
      formData.append('file', instance.file);
    }
    await APIBuilder.axios.patch<DailyReportEntity>(
      `${this.apiBuilder.$endpoint}/upload/${id}`,
      formData,
    );
  }
}
